function initWishlistCountUpdate() {
	const bubbles = document.querySelectorAll("[data-wishlist-count]");
	const isWishlistPage = window.location.href.indexOf("wishlist") > -1;

	if (!bubbles.length) {
		return null;
	}

	document.addEventListener("wishlist:item_count", (event) => {
		const count = event.detail.item_count;

		if (!count) {
			bubbles.forEach((bubble) => {
				bubble.classList.add("hidden");
			});

			return null;
		}

		bubbles.forEach((bubble) => {
			bubble.innerText = count > 99 ? "99+" : count;

			if (isWishlistPage && bubble.parentNode.tagName === "H1") {
				bubble.innerText = count > 99 ? "(99+)" : "(" + count + ")";
			}

			bubble.classList.toggle("hidden", !count);
		});
	});
}

export default initWishlistCountUpdate;
